import React, { useLayoutEffect } from "react";
import Iframe from "../../components/reusable/iframe/Iframe";
import { useNavbar } from "../../context/NavBarContext";
import { IoChevronBack } from "react-icons/io5";

const Index = () => {
    const Navbar = useNavbar();
    useLayoutEffect(() => {
        Navbar.setTogglePlace(<IoChevronBack fontSize="20" />);
        Navbar.setLogoPlace("FAQs");
      }, [])

  return (
    <div style={{ width: '100%', height: '100vh' }}>
    <Iframe
      src="https://s3.ap-southeast-1.amazonaws.com/data.bitmyanmar.info/sns/miniapp/snsmini_faq.html" // Replace with your API endpoint
      title="Terms and Conditions"
      width="100%"
      height="100%"
    />
    </div>
  );
};

export default Index;